import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';


@Injectable()
export class UserService {
  constructor(private http: HttpClient) {
  }

  GetUserList(): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/User/GetUserList'
      // , { headers: this.getHeader.getHttpHeaders() }
    )
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getUserListByRoleId(roleId): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/User/GetUserListByRoleId?roleId=' + roleId).pipe(map((data) => data),
      catchError(this.handleError));
  }

  checkPublicUser(): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Publicuser/UpdateInactiveUsers').pipe(map((data) => data),
      catchError(this.handleError));
  }


  getUserRole(email): Observable<any> {
    return this.http.get<any>(environment.APIEndpoint + "api/User/GetAdminPermissions?email=" + email)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  addSessionInfo(sessionReq: any) { 
      return this.http.post(environment.APIEndpoint + 'api/UserSessionManagement/addSessionInfo', sessionReq)
      .map((res: Response) => res);
  }
  
  getSessionInfo(SessionId: any): Observable<any> {  

    return this.http.get(environment.APIEndpoint + 'api/UserSessionManagement/getSessionInfo?SessionId='+ SessionId)
    .map((res: Response) => res);
  }
  
  updateSessionInfo(sessionReq: any) {     
  
      return this.http.post(environment.APIEndpoint + 'api/UserSessionManagement/updateSessionInfo', sessionReq)
      .map((res: Response) => res);    
  }
    
  endSessionInfo(sessionReq:any) {    
  
      return this.http.post(environment.APIEndpoint + 'api/UserSessionManagement/endSessionInfo', sessionReq)
      .map((res: Response) => res);
    
  }

  endOtherActiveSession(sessionReq:any) {   
 
    return this.http.post(environment.APIEndpoint + 'api/UserSessionManagement/endOtherActiveSession', sessionReq)
    .map((res: Response) => res);
    
  }

  load() {
    return this.http.get('../../assets/config.json')
  }

  logout():Observable<any>{
    return this.http.get("https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=http%3A%2F%2Flocalhost%3A4200").pipe(
      retry(1),
      catchError(this.handleError)
    )
  }


  private handleError(error: Response) {
    console.error(error);
    return throwError(error || 'Server error');
  }
}
